import React from 'react';
import {
  func, string, number, shape, arrayOf
} from 'prop-types';

import { Link } from 'react-router-dom';

import styles from '../permissionManagement.module.css';
import { getCompiledPath, getCommonName, formatRoleLabel } from '../../../util';
import { routes } from '../../../constants';

import { withLang } from '../../../i18n';

const UserLink = ({ userId, text }) => (
  <Link className={styles.link} to={getCompiledPath(routes.adminTools.permissions.manageUsers.user, { userId })}>
    {text}
  </Link>
);
UserLink.propTypes = {
  userId: number.isRequired,
  text: string.isRequired
};

const UserRow = ({ user, translate: t }) => {
  const {
    commonName,
    firstName,
    lastName,
    userId,
    email,
    username,
    studentNumber,
    roles
  } = user;

  const displayedCommonName = getCommonName({ commonName, firstName, lastName });

  const roleLabels = roles.map((r) => formatRoleLabel(r, t)).join(', ');

  return (
    <tr key={userId} className={styles.row}>
      <td><UserLink userId={userId} text={username} /></td>
      <td><UserLink userId={userId} text={displayedCommonName} /></td>
      <td>{email}</td>
      <td>{studentNumber}</td>
      <td>{roleLabels}</td>
    </tr>
  );
};

UserRow.propTypes = {
  user: shape({
    commonName: string.isRequired,
    firstName: string.isRequired,
    lastName: string.isRequired,
    userId: number.isRequired,
    email: string.isRequired,
    username: string.isRequired,
    studentNumber: string,
    roles: arrayOf(shape({
      roleName: string.isRequired,
      roleKind: string.isRequired,
      surveyType: string
    }))
  }).isRequired,
  translate: func.isRequired
};

export default withLang(UserRow);
